import React from 'react'
import { Table, Tag } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'

const SubmissionUnitTestResultsTable = ({ drawer, unitTests, unitTestResults, isWaitingForUnitTestResults }) => {
    const unitTestsTableColumns = [
        {
            title: 'Test',
            dataIndex: 'test',
            key: 'test',
        },
        {
            title: 'Result',
            key: 'result',
            dataIndex: 'result',
            width: '96px',
            render: result => {
                if (result === null) return <Tag color='default'>N/A</Tag>
                return (
                    <Tag icon={result ? <CheckCircleOutlined /> : <CloseCircleOutlined />} color={result ? 'success' : 'error'}>
                        {result ? 'PASSED' : 'FAILED'}
                    </Tag>
                )
            },
        },
    ]

    const unitTestsTableData = unitTests.map(unitTest => ({
        key: unitTest.id,
        test: unitTest.name,
        result: (() => {
            const found = unitTestResults.find(
                unitTestResult => unitTestResult.file_id === drawer?.file?.id && unitTestResult.ut_id === unitTest.id,
            )
            if (found === undefined) return null
            return Boolean(found?.ut_passed)
        })(),
    }))

    return (
        <Table
            columns={unitTestsTableColumns}
            dataSource={unitTestsTableData}
            pagination={false}
            loading={isWaitingForUnitTestResults}
        />
    )
}

const mapState = ({ assignment }) => {
    return {
        drawer: assignment.drawer,
        unitTests: assignment.unitTests,
        unitTestResults: assignment.unitTestResults,
        isWaitingForUnitTestResults: assignment.isWaitingForUnitTestResults,
    }
}

export default connect(mapState, null)(SubmissionUnitTestResultsTable)
